import React from 'react';
import { FiMenu } from 'react-icons/fi';
import { getBaseButtonStyles, getHoverHandlers } from './buttonStyles';

interface ToggleButtonProps {
  onClick: () => void;
  ariaLabel: string;
  ariaExpanded?: boolean;
  className?: string;
  style?: React.CSSProperties;
  onMouseEnter?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({ 
  onClick, 
  ariaLabel,
  ariaExpanded,
  className = "",
  style = {},
  onMouseEnter,
  onMouseLeave
}) => {
  const baseStyles = {
    ...getBaseButtonStyles(false), // false = square
    ...style
  };

  const defaultHoverHandlers = getHoverHandlers();

  return (
    <button
      onClick={onClick}
      style={baseStyles}
      className={className}
      aria-label={ariaLabel}
      aria-expanded={ariaExpanded}
      onMouseEnter={onMouseEnter || defaultHoverHandlers.onMouseEnter}
      onMouseLeave={onMouseLeave || defaultHoverHandlers.onMouseLeave}
    >
      <FiMenu />
    </button>
  );
};

export default ToggleButton;
